module.exports = __webpack_public_path__ + "static/media/favoriteIcon.c504dfb3.svg";